/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { FlexCol, FlexRow, Placeholder, PlaceholderText } from 'sarsaparilla';

export default function HeaderPlaceholder() {
    return (
        <div className="ap-header-placeholder">
            <FlexRow>
                <FlexCol lg={6} className="mb-3 mb-lg-0">
                    <div className="ap-header-placeholder-subtitle">
                        <PlaceholderText
                            fontSize={14}
                            lineHeight={14 * 1.2}
                            lines={1}
                            width="162px"
                        />
                    </div>
                    <div className="ap-header-placeholder-title">
                        <PlaceholderText fontSize={25} lineHeight={25 * 1.2} lines={1} />
                    </div>
                    <div className="ap-header-placeholder-metadata-list">
                        <PlaceholderText
                            fontSize={14}
                            lineHeight={14 * 1.2}
                            lines={1}
                            width="133px"
                        />
                    </div>
                    <div className="ap-header-placeholder-description">
                        <PlaceholderText fontSize={14} lineHeight={14 * 1.7} lines={3} />
                    </div>
                </FlexCol>
                <FlexCol lg={6}>
                    <Placeholder className="ap-header-placeholder-image" />
                </FlexCol>
            </FlexRow>
        </div>
    );
}
